export { default } from "./ColumnChartConfig";
